module.exports = __webpack_public_path__ + "img/hausa.7ff8b9ef.svg";